/*
 * Collection zoom toggle (Phase E, 2026-05-17)
 * Two states only:
 *   desktop: out = 3 columns, in = 4 columns
 *   mobile : out = 1 column,  in = 2 columns
 *
 * Default state on first visit = 'in' (denser grid, matches theme default).
 * State persists via localStorage; restored on every collection page.
 * Override is written on the same inline-style channel as collection.liquid
 * so no !important / specificity battle is needed.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'siedres_collection_zoom';
  var VALID = { out: 1, 'in': 1 };

  // Viewport-aware column counts.
  // UX:  minus (−) = zoom OUT = more products visible, smaller cards
  //      plus  (+) = zoom IN  = fewer products visible, larger cards
  // Default state is 'out' so users land on the denser (more-products)
  // view across all breakpoints.
  //   ≥1400px  desktop-wide: out=6 (default), in=4
  //   990-1399 laptop:       out=5 (default), in=3
  //   750-989  tablet:       out=4 (default), in=2
  //   <750     mobile:       out=2 (default), in=1
  function getColumnMap() {
    var w = window.innerWidth;
    if (w >= 1400) return { out: 6, 'in': 4 };
    if (w >= 990)  return { out: 5, 'in': 3 };
    if (w >= 750)  return { out: 4, 'in': 2 };
    return { out: 2, 'in': 1 };
  }

  function readState() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return VALID[v] ? v : 'out';
    } catch (e) { return 'out'; }
  }

  function writeState(v) {
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) { /* private mode */ }
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function applyState(state) {
    var grid = document.querySelector('.grid-outer .grid');
    if (!grid) return;

    var mobile = isMobile();
    var map = getColumnMap();
    var cols = map[state];
    // 'important' priority so JS override beats the CSS !important
    // responsive baseline set in dvn-collection-redesign.css.
    grid.style.setProperty('--columns', String(cols), 'important');
    if (mobile) grid.style.setProperty('--columns-mobile', String(cols), 'important');

    document.querySelectorAll('[data-zoom-toggle] [data-zoom-action]').forEach(function (btn) {
      var act = btn.getAttribute('data-zoom-action');
      btn.classList.toggle('is-active', act === state);
    });
  }

  function handleClick(e) {
    var btn = e.target.closest('[data-zoom-action]');
    if (!btn) return;
    e.preventDefault();
    var action = btn.getAttribute('data-zoom-action');
    if (!VALID[action]) return;
    if (action === readState()) return;
    writeState(action);
    applyState(action);
  }

  function handleResize() {
    applyState(readState());
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function init() {
    if (!document.querySelector('[data-zoom-toggle]')) return;
    document.addEventListener('click', handleClick);
    window.addEventListener('resize', debounce(handleResize, 150));
    applyState(readState());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
